import { PawPrint, User, ShoppingCart, Stethoscope } from "lucide-react";

export const statCards = (data: any) => [
    {
        title: "Total Pet Owners",
        value: data?.patients,
        icon: <PawPrint size={24} />,
        gradient: "from-teal-400 to-teal-600",
        navigatePath: "/users?role=parent",
    },
    {
        title: "Total Pets",
        value: data?.pets,
        icon: <User size={24} />,
        gradient: "from-blue-400 to-blue-600",
        navigatePath: "/users?role=Pets", 
    },
    {
        title: "Total Service Providers",
        value: data?.serviceProviders,
        icon: <ShoppingCart size={24} />,
        gradient: "from-purple-400 to-purple-600",
        navigatePath: "/users?role=service_provider",
    },
    {
        title: "Total Veterinarians",
        value: data?.providers,
        icon: <Stethoscope size={24} />,
        gradient: "from-orange-400 to-orange-600",
        navigatePath: "/users?role=veterinarian",
    },
    {
        title: "Total Vendors",
        value: data?.vendors,
        icon: <ShoppingCart size={24} />,
        gradient: "from-green-400 to-green-600",
        navigatePath: "/users?role=vendor",
    },
];